import { render, staticRenderFns } from "./PostFilterPage.vue?vue&type=template&id=12b88299"
import script from "./PostFilterPage.vue?vue&type=script&lang=js"
export * from "./PostFilterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports